import React, { Children } from 'react';

import { Box, Collapse, useDisclosure } from '@chakra-ui/react';

import { ArrowDown, ArrowUp } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';

const ToggleButton = ({ text, onClick = () => {}, icon }) => (
  <Button StartIcon={icon} variant="tertiary" onClick={onClick}>
    {text}
  </Button>
);

const CollapsableCompetencyRabbit = ({ children }) => {
  const { isOpen, onToggle } = useDisclosure();
  const arrayChildren = Children.toArray(children);
  const visibleArray = arrayChildren.slice(0, 7);
  const collapsedArray = arrayChildren.slice(7);

  if (!collapsedArray.length) {
    return children;
  }

  return (
    <Box
      sx={{
        maxHeight: '124px',
      }}
    >
      {visibleArray}
      {!isOpen && <ToggleButton text="Show All" icon={ArrowDown} onClick={onToggle} />}
      <Collapse in={isOpen} animateOpacity>
        {collapsedArray}
      </Collapse>
      {isOpen && <ToggleButton text="Show Less" icon={ArrowUp} onClick={onToggle} />}
    </Box>
  );
};

export { CollapsableCompetencyRabbit };
